import React from 'react';

const CsvFile = () => (
  <svg width="21" height="24" viewBox="0 0 21 24" fill="none" xmlns="">
    <g id="Group 11">
      <g id="pdf">
        <path
          id="Path"
          d="M4.5 0C3.675 0 3 0.675 3 1.5V22.5C3 23.325 3.675 24 4.5 24H19.5C20.325 24 21 23.325 21 22.5V6L15 0H4.5Z"
          fill="#DCE0DA"
        />
        <path
          id="Path_2"
          d="M16.5 6H21L15 0V4.5C15 5.325 15.675 6 16.5 6Z"
          fill="#1D211A"
        />
        <path id="Path_3" d="M21 10.5L16.5 6H21V10.5Z" fill="#BFC4BA" />
        <path
          id="Path_4"
          d="M18 19.5C18 19.9125 17.6625 20.25 17.25 20.25H0.75C0.3375 20.25 0 19.9125 0 19.5V12C0 11.5875 0.3375 11.25 0.75 11.25H17.25C17.6625 11.25 18 11.5875 18 12V19.5Z"
          fill="#378906"
        />
        <path
          id="Path_5"
          d="M17.25 20.25H3V21H17.25C17.6625 21 18 20.6625 18 20.25V19.5C18 19.9125 17.6625 20.25 17.25 20.25Z"
          fill="#D1D8CD"
        />
      </g>
      <path
        id="CSV"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.68779 18.0839C4.75179 18.0839 5.33979 17.5169 5.67579 16.9359L4.82179 16.5229C4.62579 16.9079 4.20579 17.2019 3.68779 17.2019C2.87579 17.2019 2.25979 16.5509 2.25979 15.6689C2.25979 14.7869 2.87579 14.1359 3.68779 14.1359C4.20579 14.1359 4.62579 14.4369 4.82179 14.8149L5.67579 14.3949C5.34679 13.8139 4.75179 13.2539 3.68779 13.2539C2.32279 13.2539 1.23779 14.2339 1.23779 15.6689C1.23779 17.1039 2.32279 18.0839 3.68779 18.0839ZM8.42979 18.0839C9.68979 18.0839 10.2988 17.4399 10.2988 16.5859C10.2988 15.5499 9.31879 15.3189 8.54879 15.1439C8.00979 15.0179 7.61779 14.9199 7.61779 14.6049C7.61779 14.3249 7.85579 14.1289 8.30379 14.1289C8.75879 14.1289 9.26279 14.2899 9.64079 14.6399L10.1938 13.9119C9.73179 13.4849 9.11579 13.2609 8.37379 13.2609C7.27479 13.2609 6.60279 13.8909 6.60279 14.6679C6.60279 15.6966 7.55608 15.915 8.31426 16.0887L8.34579 16.0959C8.88479 16.2219 9.29079 16.3409 9.29079 16.6909C9.29079 16.9569 9.02479 17.2159 8.47879 17.2159C7.83479 17.2159 7.32379 16.9289 6.99479 16.5859L6.44879 17.3419C6.88979 17.7829 7.53379 18.0839 8.42979 18.0839ZM15.8248 13.3309L14.0258 17.9999H12.7798L10.9738 13.3309H12.1078L13.4028 16.9219L14.6908 13.3309H15.8248Z"
        fill="white"
      />
    </g>
  </svg>
);

export default CsvFile;
